import { createReducer } from "../commons/js/utils/reducer";
import { fromPairs as _fromPairs } from "lodash";

const initialState = {
    pastOrders: [],
    isLoading: false,
    uploadType: "",
    materialName: "",
    groupedComponents: [],
    showAddMaterial: false,
    fabMaterials: [],
    fieldMaterials: [],
    url: "",
    pdfStatus: "",
    material: { value: "", error: "", showError: "" },
    length: { value: "", error: "", showError: "" },
    size: { value: "", error: "", showError: "" },
    description: { value: "", error: "", showError: "" },
    itemNote: { value: "", error: "", showError: "" },
    facilityList: [],
    selectedFacility: { value: null, label: '' }
}
export const purchaseOrderReducer = createReducer(initialState, {
    SET_PAST_ORDERS: (state, action) => {
        return {
            ...state,
            pastOrders: action.payload.value,
        };
    },
    SET_ACTIVE_FACILITITES: (state, action) => {
        return {
            ...state,
            facilityList: action.payload.facilities
        }
    },
    SET_SELECTED_FACILITY_PURCHASE_ORDER: (state, action) => {
        return {
            ...state,
            selectedFacility: action.payload.selectedFacility
        }
    },
    SET_LOADING: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    SET_UPLOAD_TYPE: (state, action) => {
        return {
            ...state,
            uploadType: action.payload.value
        }
    },
    SET_MATERIAL_NAME: (state, action) => {
        return {
            ...state,
            materialName: action.payload.value
        }
    },
    SET_GROUPED_COMPONENTS: (state, action) => {
        return {
            ...state,
            groupedComponents: action.payload.value
        }
    },
    SET_SHOW_ADD_MATERIAL_POPUP: (state, action) => {
        return {
            ...state,
            showAddMaterial: action.payload.value
        }
    },
    SET_LENGTH: (state, action) => {
        return {
            ...state,
            length: {
                ...state.value,
                value: action.payload.value,
            }
        }
    },
    SET_SIZE: (state, action) => {
        return {
            ...state,
            size: {
                ...state.size,
                value: action.payload.value,
            }
        }
    },
    SET_DESCRIPTION: (state, action) => {
        return {
            ...state,
            description: {
                ...state.description,
                value: action.payload.value,
            }
        }
    },
    SET_ITEM_NOTES: (state, action) => {
        return {
            ...state,
            itemNote: {
                ...state.itemNote,
                value: action.payload.value,
            }
        }
    },
    SET_MATERIAL_TYPE: (state, action) => {
        return {
            ...state,
            material: {
                ...state.material,
                value: action.payload.value
            }
        }
    },
    SET_MATERIAL: (state, action) => {
        return {
            ...state,
            fabMaterials: action.payload.fabMaterials,
            fieldMaterials: action.payload.fieldMaterials,
        };
    },
    SET_FIELD_ERRORS: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(
            Object.entries(errors).map((error) => {
                const [key, value] = error;
                return [
                    key,
                    {
                        ...state[key],
                        error: value,
                    },
                ];
            })
        );

        return {
            ...state,
            ...loadedFields,
        };
    },
    CLEAR_FORM: (state, action) => {
        return {
            ...state,
            length: { ...initialState.length },
            size: { ...initialState.size },
            description: { ...initialState.description },
            itemNote: { ...initialState.itemNote },
            material: { ...initialState.material }
        }
    },
    SET_PDF_STATUS: (state, action) => {
        return {
            ...state,
            pdfStatus: action.payload.status,
            url: action.payload.url
        }
    }

})
export default purchaseOrderReducer;